export default "__VITE_ASSET__JJHJywcE__"